import React from 'react';
import PropTypes from 'prop-types';
import CommunityHeaderContent from './communityHeaderContent';
import CommunityHeaderNavBar from './communityHeaderNavBar';
import linkUtils from 'src/utils/linkUtils';

const CommunityHeader = ({ community, currentUser, newbies, currentPage,
  onFollow, isWriteCTAvisible, isSmallCommunity, trackingSection }) => {
  const headerCoverStyle = {
    backgroundImage: `url(${linkUtils.generateGroupBannerUrl(community.bannerImageHash)})`,
  };
  return (
    <div className="community-header">
      <div
        className="community-header__cover"
        style={headerCoverStyle}
      />
      <CommunityHeaderContent
        community={community}
        currentUser={currentUser}
        isWriteCTAvisible={isWriteCTAvisible}
        newbies={newbies}
        trackingSection={trackingSection}
        onFollow={onFollow}
      />
      <CommunityHeaderNavBar
        community={community}
        currentPage={currentPage}
        currentUser={currentUser}
        isSmallCommunity={isSmallCommunity}
      />
    </div>
  );
};

CommunityHeader.propTypes = {
  community: PropTypes.object,
  currentPage: PropTypes.string,
  currentUser: PropTypes.object,
  isSmallCommunity: PropTypes.bool,
  isWriteCTAvisible: PropTypes.bool,
  newbies: PropTypes.array,
  onFollow: PropTypes.func,
};

CommunityHeader.defaultProps = {
  community: {},
  currentUser: {},
  isSmallCommunity: false,
  isWriteCTAvisible: true,
  currentPage: '',
  newbies: [],
  onFollow: () => {},
};

export default CommunityHeader;



// WEBPACK FOOTER //
// ./src/modules/community/shared/components/header/communityHeader.js